import { render } from "./base-autocomplete.vue?vue&type=template&id=3841f340&ts=true"
import script from "./base-autocomplete.vue?vue&type=script&lang=ts"
export * from "./base-autocomplete.vue?vue&type=script&lang=ts"

import "./base-autocomplete.vue?vue&type=style&index=0&id=3841f340&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__